module.exports = __webpack_public_path__ + "static/media/icons8-kubernetes.67951dcf.svg";